// This file is meant to be exporting enums only
// Please refrain from importing anything to it and from introducing anything here other than enums
// Doing so will make downstream services include runtime code from this service
export enum AutoDestroyStatus {
  NONE,
  MARKED_FOR_DELETION,
  ALERTED_BEFORE_DELETION_2H,
  ALERTED_BEFORE_DELETION_2D
}

export enum DeploymentType {
  deploy = 'deploy',
  destroy = 'destroy',
  prPlan = 'prPlan',
  driftDetection = 'driftDetection',
  task = 'task',
  remotePlan = 'remotePlan',
  dryRun = 'dryRun'
}

// order matters, the first status is the most severe
export enum DriftStatus {
  ERROR,
  DRIFTED,
  OK,
  NEVER_RUN,
  DISABLED
}

// Placeholder repository of blueprints that never clone: remote-backend (Terraform CLI) workspaces and
// imported TFC workspaces without VCS. ~9,021 prod blueprints persist this exact value, so it can never
// change (the name can). ATH-439.
// One value for both writers on purpose: blueprint-service validates the repository with git-url-parse,
// and this is the only placeholder that parses. Imported workspaces used to send 'http://', which never
// did, so no blueprint holds it (ENG-2922).
// Backend-internal: it reaches frontend types only through the api.enum re-export - not a public contract.
export enum PlaceholderRepository {
  NoVcs = 'http://.'
}

export enum VerifiableVcsProvider {
  github = 'github',
  gitlab = 'gitlab',
  azureDevOps = 'azureDevOps'
}
